import React from 'react';
import AboutMembers from './AboutMembers';
import AnnourFooter from './AnnourFooter';

const AboutPage = () => {
  return (
    <div className="min-h-screen pt-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-6xl mx-auto bg-white/90 backdrop-blur-sm p-8 shadow-2xl rounded-xl border border-blue-100">
        <AboutMembers />
      </div>
      <AnnourFooter />
    </div>
  );
};

export default AboutPage;
